<template>
  <v-row no-gutters>
    
    <v-col class="pa-2 text-center" cols="12">
      <v-btn
        :disabled="!items || !items.length"
        outlined
        rounded
        @click="showSend = !showSend"
      >
        ارسال به شماره‌های انتخاب شده
        <v-icon right>mdi-chevron-{{ showSend ? "up" : "down" }}</v-icon>
      </v-btn>
    </v-col>
    <!--  -->
    <v-col cols="12">
      <v-expand-transition>
        <v-row v-if="showSend" no-gutters>
          <!--          <v-col class="pa-2" cols="12" md="6">-->
          <!--            <v-select v-model="phoneToSend" :items="phoneItems" :menu-props="{offsetY: true}" class="rounded-lg" dense-->
          <!--                      hide-details label="ارسال دفترچه تلفن" outlined/>-->
          <!--          </v-col>-->

          <v-col class="d-flex align-center pa-2" cols="12">
            <!-- <pattern-dialog
              v-model="selectedRow"
              :text.sync="texts"
              @reload="(e) => (rerender = e)"
            /> -->
            <v-btn class="btn-edit" depressed @click="dialog = true">
              <v-icon left>mdi-clipboard-list-outline</v-icon>
              تغییر پترن/کمپین
            </v-btn>
            {{ selectedRow }}
            <save-steps
              v-model="dialog"
              :selected.sync="selectedRow"
              @reload="(e) => (rerender = e)"
            />
            <v-spacer />
            <date-picker
              v-model="date"
              :label="$t('FORMS.SendTime')"
              :min="nowDateTimeString()"
              auto-submit
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              format="YYYY-MM-DD HH:mm:ss"
              type="datetime"
            />
          </v-col>

          <v-col v-if="rerender && !selectedCamp" class="d-flex pa-2" cols="12">
            <div
              v-if="generateText"
              class="col-md-4 rounded p-5"
              style="background: rgba(193, 193, 193, 0.58)"
            >
              <p>پیام انتخاب شده:</p>

              <p
                class="font-size-lg"
                style="white-space: break-spaces"
                v-text="generateText"
              ></p>
            </div>

            <div
              v-if="inputs.length > 0"
              class="col-md mr-1 rounded p-5"
              style="background: rgba(193, 193, 193, 0.58)"
            >
              <p>ورودی های اجباری:</p>

            <template v-for="(input, index) in inputs">
              <v-text-field
                v-if="input.state !== 'userInfo'"
                :key="`${index}-data`"
                v-model="texts[index]"
                :label="input.text"
                class="my-2"
                dense
              >
                <template v-slot:append-outer>
                  <input-generate-menu
                    :value="input.state"
                    @input="(val) => { input.state = val; texts[index] = ''; }"
                  />
                </template>
              </v-text-field>

              <v-autocomplete
                v-else
                :key="`${index}-info`"
                v-model="texts[index]"
                :items="userInfoItems"
                :label="input.text"
                dense
                class="my-2"
              >
                <template v-slot:append-outer>
                  <input-generate-menu
                    :value="input.state"
                    @input="(val) => { input.state = val; texts[index] = ''; }"
                  />
                </template>
              </v-autocomplete>
            </template>
            </div>
          </v-col>

          <v-col v-else-if="selectedCamp" class="pa-2" cols="12">
            <v-card-title>
              <span class="grey--text font-size-h6">کمپین انتخاب شده:</span>
              <span class="primary--text px-2">شناسه {{ selectedRow.id }}</span>
            </v-card-title>
          </v-col>

          <v-col col="12">
            <v-card-actions class="justify-end">
              <v-btn
                :disabled="!isValid"
                :loading="loading"
                class="btn-send-sms"
                @click="sendPattern"
              >
                <span class="flaticon2-send-1 icon-md"></span>
                {{ $t("FORMS.Send") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-expand-transition>
    </v-col>
  </v-row>
</template>

<script>
import SaveSteps from "@/view/pages/contacts/saveSteps.vue";
import PatternDialog from "@/view/content/pickers/patternDialog.vue";
import CustomDatePicker from "@/view/content/pickers/custom-date-picker.vue";
import InputGenerateMenu from "@/core/plugins/TitleRibbon/components/contacts/pattern/inputGenerateMenu.vue"


export default {
  name: "contactSendsPattern",

  components: { CustomDatePicker, PatternDialog, SaveSteps,InputGenerateMenu },

  props: {
    items: Array,
    tableProps: Object,
  },

  data: () => ({
     userInfoItems: [
    { value: "preName", text: "پیشوند" },
    { value: "name", text: "نام" },
    { value: "lastName", text: "نام خانوادگی" },
    { value: "companyName", text: "شرکت" },
    { value: "jobTitle", text: "عنوان شغلی" },
    { value: "phone", text: "شماره تلفن" },
  ],
    dialog: false,
    loading: false,
    showSend: false,
    selectedRow: null,
    selectedCamp: false,
    inputs: [],
    texts: [],
    rerender: true,
    date: "",
    // phoneToSend: 'all',
    phones: [],
  }),

  mounted() {
    this.date = this.nowDateTimeString();
  },

  computed: {
    // phoneItems() {
    //   return [
    //     {value: 'all', text: 'همه شماره‌'},
    //     {value: 'checked', text: 'انتخاب شده ها', disabled: true},
    //   ]
    // },
    isValid() {
      return (
        this.selectedRow?.id &&
        this.texts.filter((x) => x).length === this.inputs.length &&
        !!this.date &&
        !!this.items?.length
      );
    },
    generateText() {
      const regex = new RegExp(/data\d+/, "gd");
      let text = this?.selectedRow?.content;

      this.inputs = this?.selectedRow?.content?.match(regex) ?? [];

      this.texts.forEach((item, index) => {
        text = text.replace(this.inputs[index], item);
      });

      return text;
    },
  },

  watch: {
    // phoneToSend(val) {
    //   console.log('phoneToSend: ', val)
    // },
 selectedRow: {
    deep: true,
    handler(val) {
      this.selectedCamp = Boolean(val && ("messages" in val || "campId" in val));

      if (val?.content) {
        const matches = val.content.match(/data\d+/g) || [];
        if (matches.length !== this.inputs.length) {
          this.inputs = matches.map((item) => ({
            text: item,
            state: "data",
          }));
          this.texts = matches.map(() => "");
        }
      } else {
        this.inputs = [];
        this.texts = [];
      }
    },
    immediate: true,
  },  },

  methods: {
    sendPattern() {
      // if (!this.items?.length) {
      //   this.getAllPhones()
      //     .then(data => this.submitNew(data))
      // } else {
      const phones = this.items?.map((item) => item.phone);
      this.submitNew(phones);
      // this.dialog = true;
      // }
    },
    // getAllPhones() {
    //   return new Promise((resolve, reject) => {
    //     this.requestApiGet('contact', {
    //       ...this.tableProps,
    //       getTotal: true
    //     })
    //       .then(({data}) => {
    //         resolve(data.data?.map(item => item.phone))
    //       })
    //       .catch(({response}) => {
    //         reject('rejected')
    //       })
    //   })
    // },
    submitNew(phones) {
      this.loading = true;

      {
        let data = {
          To: phones.join(","),
          [this.selectedCamp ? "campId" : "MsgId"]: this.selectedRow.id,
          timeouted_at: this.date,
        };

        if (!this.selectedCamp)
          this.texts.forEach((item, index) => {
            data[this.inputs[index]] = item;
          });

        this.requestApiPostPayamak("admin/message/send/pattern/", data)
          .then((result) => {
            this.$modal.success("موفقیت", result.data.msg);
            this.selectedRow = null;
            this.selectedCamp = false;
            this.inputs = [];
            this.texts = [];
            this.rerender = true;
            // this.phones = [];
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>

<style scoped></style>
